// extracted by mini-css-extract-plugin
module.exports = {"wholePage":"Layout_wholePage__VL603","mainContent":"Layout_mainContent__Pv1Rw","extraWide":"Layout_extraWide__H7IFF","mainContainer":"Layout_mainContainer__esXwQ"};